import { render, staticRenderFns } from "./AdminDebug.vue?vue&type=template&id=042c0cf7&scoped=true&"
import script from "./AdminDebug.vue?vue&type=script&lang=js&"
export * from "./AdminDebug.vue?vue&type=script&lang=js&"
import style0 from "./AdminDebug.vue?vue&type=style&index=0&id=042c0cf7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042c0cf7",
  null
  
)

export default component.exports